var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickBig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tick-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5861 4.32093C22.0966 4.78556 22.141 5.58407 21.6852 6.10445L9.88394 19.5781C9.64885 19.8465 9.31261 20 8.95963 20C8.60664 20 8.27041 19.8465 8.03532 19.5781L3.31483 14.1887C2.85904 13.6683 2.90338 12.8698 3.41386 12.4051C3.92435 11.9405 4.70767 11.9857 5.16345 12.5061L8.95963 16.8403L19.8365 4.42189C20.2923 3.9015 21.0757 3.85631 21.5861 4.32093Z",
    fill: "#0F1653"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickBig);
export default __webpack_public_path__ + "static/media/tick-big.2389df7b79a2f50020173877f8e412fd.svg";
export { ForwardRef as ReactComponent };